import {Component, Input} from '@angular/core';

@Component({
    selector: 'app-item-status',
    templateUrl: './item-status.component.html',
    styleUrls: ['./item-status.component.scss'],
    standalone: false
})
export class ItemStatusComponent {

    @Input() status: boolean;
}
